import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataCheckboxRow from './EcommDataCheckboxRow';

import { shouldDisplayIsWeekend } from '../../helpers/helpers';
import { LocationType } from '../../validation';
import EcommDoubleBookingRows from './EcommDoubleBookingRows';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import {
  ecommTableNumericRows,
  ecommTableDropdownRows,
} from '../../constants/ecommDataTableRowLabelAndValueKey';
import { numberRowMap, dropdownRowMap } from '../../helpers/ecommTableHelpers';

class EcommDataAccPrepTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accPrepData: {
        ...props.accPrepData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    this.saveChange(name, value, key);
  }

  saveChange = (name, value, key) => {
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      accPrepData: {
        ...prevState.accPrepData,
        [key]: {
          ...prevState.accPrepData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { accPrepData } = this.state;
      saveOne({
        date: accPrepData[key].date,
        locationType: 'accessoryprep',
        locationId: accPrepData[key].locationId,
        isWeekendPrep: accPrepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = async (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      accPrepData: {
        ...prevState.accPrepData,
        [key]: {
          ...prevState.accPrepData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { accPrepData } = this.state;
      saveOne({
        date: accPrepData[key].date,
        locationType: 'accessoryprep',
        locationId: accPrepData[key].locationId,
        isWeekendPrep: accPrepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    });
  };

  handleIsWeekendPrepCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isWeekendPrep: checked };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      accPrepData: {
        ...prevState.accPrepData,
        [key]: {
          ...prevState.accPrepData[key],
          isWeekendPrep: checked
        }
      }
    }),
    () => {
      const { accPrepData } = this.state;
      saveOne({
        date: accPrepData[key].date,
        locationType: 'accessoryprep',
        locationId: accPrepData[key].locationId,
        isWeekendPrep: accPrepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      })
    })
  }

  handleDoubleStylistCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isDoubleStylist: checked };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      accPrepData: {
        ...prevState.accPrepData,
        [key]: {
          ...prevState.accPrepData[key],
          isDoubleStylist: checked
        }
      }
    }),
    () => {
      const { accPrepData } = this.state;
      saveOne({
        date: accPrepData[key].date,
        locationType: 'accessoryprep',
        locationId: accPrepData[key].locationId,
        isWeekendPrep: accPrepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      })
    });
  };

  getTabIndex = (column)=> {
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { accPrepData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      specialProjectOptions,
      canEdit,
      relatedLocationType
    } = this.props;

    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="AccPrepTitle"
            tableTitle={i18n.t('location:accPrepTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(accPrepData).map(element =>
                accPrepData[element].accPrepName)}
            />
            {ecommTableNumericRows.slice(0, 3).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accPrepData))}
            {ecommTableNumericRows.slice(7, 11).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, accPrepData))}
            {ecommTableDropdownRows.slice(0, 2).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, accPrepData))}
            <EcommDoubleBookingRows 
              locationType={relatedLocationType}
              saveChange={this.saveChange}
              canEdit={canEdit}
              studioData={accPrepData}
              getTabIndex={this.getTabIndex}
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={accPrepData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={accPrepData}
              handleChange={this.handleChange}
            />
            {shouldDisplayIsWeekend(accPrepData[0].date) && (
              <EcommDataCheckboxRow 
                rowTitle={i18n.t('location:isWeekendPrep').toUpperCase()}
                tableDataSet={accPrepData}
                disabled={!canEdit}
                checkboxKey="isWeekendPrep"
                rowClassName="studioDataRight"
                onChange={this.handleIsWeekendPrepCheckbox}
              />
            )}
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataAccPrepTable.propTypes = {
  accPrepData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  relatedLocationType: LocationType.isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  saveOne: PropTypes.func.isRequired,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  startTabIndex: PropTypes.number
};

EcommDataAccPrepTable.defaultProps = {
  startTabIndex: 200
}

export default EcommDataAccPrepTable;